import { render, staticRenderFns } from "./chooseaccount.vue?vue&type=template&id=6b18b3af&scoped=true"
import script from "./chooseaccount.vue?vue&type=script&lang=js"
export * from "./chooseaccount.vue?vue&type=script&lang=js"
import style0 from "./chooseaccount.vue?vue&type=style&index=0&id=6b18b3af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18b3af",
  null
  
)

export default component.exports